import DevToggle from "components/DevToggle";
import { LifecycleScriptStatus } from "components/Environment/shared/BuildTypes";
import { getVerbBuildStatusFromTasks } from "components/Environment/utils/environtmentUtils";
import { Environment } from "components/Environment/utils/types";
import LifecycleScriptLogDisplay from "components/LifecycleScriptLogs";
import { LogViewer } from "components/LogViewer";
import NotebookList from "components/NotebookList";
import HtmlRenderer from "components/Notebooks/HtmlRenderer";
import FlatCard from "components/UI-lib/FlatCard";
import CustomizeVerb from "components/Verb/CustomizeVerb";
import { VerbBuildComponent } from "components/Verb/VerbBuildComponent";
import { getVerbBuildConfigFromWorkspace } from "components/Verb/utils";
import Workspace from "entities/Workspace.entity";
import { VerbBuildStatus } from "models/Workspace.model";
import React, { useEffect, useMemo, useState } from "react";
interface LogsSettingsProps {
  workspaceId: string;
  setShowButton: (b: boolean) => void;
  environment: Environment;
  initialVerbLoad: boolean;
  lifecycleScriptLog: string | null;
}
const LogsSettings: React.FC<LogsSettingsProps> = (props) => {
  return (
    <>
      <div className="flex flex-row items-end ">
        <div className="mr-3">
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-secondary">
            {props.environment.build?.vm ? "VM Logs" : "Container Logs"}
          </h1>
        </div>
      </div>
      <hr className="w-[100%] my-3 dark:border dark:border-zinc-800" />
      <div>
        <VerbBuildComponent
          workspaceId={props.workspaceId}
          setShowButton={props.setShowButton}
          environment={props.environment}
          initialVerbLoad={props.initialVerbLoad}
        />
      </div>
      {props.environment.lifecycle_scripts &&
        props.environment.lifecycle_scripts.length > 0 && (
          <>
            <div className="flex flex-row items-end mt-8">
              <div className="mr-3">
                <h1 className="text-2xl font-semibold text-gray-900 dark:text-secondary">
                  Script Logs
                </h1>
              </div>
            </div>
            <hr className="w-[100%] my-3 dark:border dark:border-zinc-800 mb-8" />

            {props.environment &&
            getVerbBuildStatusFromTasks(props.environment.tasks || []) !==
              VerbBuildStatus.Completed ? (
              <div className="flex w-full mt-5">
                <FlatCard isLoading={false}>
                  <p className="text-sm text-gray-700 dark:text-secondary font-mono text-center">
                    Logs will appear here when the VM is built.
                  </p>
                </FlatCard>
              </div>
            ) : (
              <LogViewer
                logs={props.lifecycleScriptLog || ""}
                title={
                  props.environment.lifecycle_scripts[0].last_run.status ===
                  LifecycleScriptStatus.COMPLETED
                    ? "Your script completed successfully"
                    : props.environment.lifecycle_scripts[0].last_run.status ===
                      LifecycleScriptStatus.FAILED
                    ? "Your script ran into an error"
                    : "Your script is running..."
                }
                didSucceed={
                  props.environment.lifecycle_scripts[0].last_run.status ===
                  LifecycleScriptStatus.COMPLETED
                }
                didFail={
                  props.environment.lifecycle_scripts[0].last_run.status ===
                  LifecycleScriptStatus.FAILED
                }
              />
            )}
          </>
        )}
    </>
  );
};

export default LogsSettings;
